export default __webpack_public_path__ + "static/media/etna-dolce.77865816.png";